import React from 'react'
import DisplayHtml from 'src/components/Forms/RichTextEditor/DisplayHtml'
import { useCandidateNotesById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const candidate = useCandidateNotesById(id)
  return (
    <DisplayHtml value={candidate?.notes ?? ''} />
  )
}

export default Body
